<template>
	<div class="example-group">
		<hr v-if="answerInputidx > 0"/>
		<div class="item-row">
			<div class="item-cell">{{info}}</div>
		</div>
		<div class="item-row" style="margin-top:4px" v-for="(example, i) in exampleList" :key="'ex' + i">
			<button class="item-cell item-cell button" v-on:click="onNumberClick" v-bind:class="[isSelected(i) ? 'button-fill':'button-outline']" style="width:40px;">
				<span class="badge color-black" v-if="isDisplayAnswer(i)">{{i+1}}</span> 
				<span v-else>{{i+1}}</span>
			</button>
			<div class="item-cell">
				{{example}}
			</div>
		</div>
	</div>
</template>

<script>
import MODULE from '../../js/common/module';
import store from '../../js/store';
import MathLive from 'mathlive';

export default {
	props: {
		examNo: { default: 0 },
		subExamIdx: { default: 0 },
		answerInputidx: { default: 0 },
	},
	data() {
		return {
			infoHtml: "",
		}
	},
	computed: {
		mode() {
			var mode = this.getCommonObj().mode;
			return mode;
		},
		info() {
			return this.getAnswerInput().info;
		},
		answer() {
			return this.getAnswerInput().answer;
		},
		inputAnswer: {
			get() {
				return this.getAnswerInput().inputAnswer;
			},
			set(newValue) {
				var answerInput = this.getAnswerInput();
				answerInput.inputAnswer = newValue;
			}
		},
		exampleList() {
			return this.getAnswerInput().exampleList;
		}
	},
	mounted() {
		this.renderInfo();
	},
	methods: {
		getCommonObj() {
			return store.getters.commonObj;
		},
		getAnswerInput() {
			var answers = this.getCommonObj().answers;

			var examIndex = this.examNo - 1;
			var exam = answers[examIndex];
			var subExam = exam.subExamList[this.subExamIdx];
			var answerInput = subExam.answerInputList[this.answerInputidx];

			return answerInput;
		},
		isSelected(exampleIndex) {
			var exampleNo = exampleIndex + 1;
			return this.inputAnswer.includes(exampleNo);
		},
		isDisplayAnswer(exampleIndex) {
			var exampleNo = exampleIndex + 1;
			return this.mode=="SCORE" && this.answer.includes(exampleNo);
		},
		onNumberClick(e) {
			if (this.mode != "ANSWER") {
				return;
			}

			const thisButton = $(e.currentTarget);
			const exampleGroup = thisButton.closest(".example-group");
			const buttons = exampleGroup.find("button");

			if (thisButton.hasClass("button-fill")) {
				thisButton.removeClass("button-fill");
				thisButton.addClass("button-outline");
			} else {
				thisButton.removeClass("button-outline");
				thisButton.addClass("button-fill");
			}

			let value = "";
			for (var i=0; i<buttons.length; i++) {
				let button = $(buttons[i]);

				if (button.hasClass("button-fill")) {
					if (i > 0) {
						value = value + ".";
					}

					value = value + (i + 1);
				}
			}

			this.inputAnswer = value;
		},
		renderInfo() {
			let html = this.info;
			if (MODULE.Util.isEmpty(html)) {
				this.infoHtml = "짝짓기형 답안"
			} else {
				this.infoHtml = MathLive.latexToMarkup(this.info, "displaystyle");
			}
		},
	}
}

</script>